<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    values: ['', '', '', '', '', '']
  }),
  computed: {
    code: vm => vm.values.join('')
  },
  watch: {
    values () {
      this.$emit('input', this.code)
      if (this.code.length === this.values.length) {
        this.$emit('update', this.code)
      }
    },
    value (newValue) {
      if (!newValue) {
        this.resetValues()
      }
    }
  },
  methods: {
    focus ($event) {
      $event.target.select($event)
    },
    keydown ($event, index) {
      const prevIndex = index - 1
      const nextIndex = index + 1

      switch ($event.key) {
        case 'Backspace': {
          $event.preventDefault()
          if ($event.target.selectionEnd > 0) {
            this.$set(this.values, index, '')
          } else if (prevIndex >= 0) {
            this.$set(this.values, prevIndex, '')
            this.$refs.inputs[prevIndex].focus()
          }
          break
        }
        case 'ArrowLeft':
          $event.preventDefault()
          this.$refs.inputs[prevIndex]?.focus()
          break
        case 'ArrowRight':
          $event.preventDefault()
          this.$refs.inputs[nextIndex]?.focus()
          break
        case 'Tab':
          // Allow Tab key to function normally
          break
        case 'v':
          // Allow paste
          if ($event.metaKey || $event.ctrlKey) {
            break
          }
          $event.preventDefault()
          break
        default: {
          if (
            // Prevent non-number keys
            ($event.key.length > 1 || isNaN(parseInt($event.key))) ||
            // Prevent more than one character per field
            (this.values[index]?.length === 1 && $event.target.selectionStart === $event.target.selectionEnd)
          ) {
            $event.preventDefault()
          }
        }
      }
    },
    input (value, currentIndex) {
      this.$refs.inputs[currentIndex + 1]?.focus()
    },
    paste ($event) {
      const pasteValue = $event.clipboardData.getData('text').trim()
      const newValues = pasteValue.split('')
      const newValuesLength = newValues.length
      this.$refs.inputs[newValuesLength >= 6 ? 5 : newValuesLength - 1]?.focus()
      newValues.length = 6
      this.values = [...newValues]
    },
    resetValues () {
      this.values = ['', '', '', '', '', '']
      this.$nextTick(() => this.$refs.inputs[0].focus())
    }
  }
}
</script>

<template>
  <div class="linked-text-fields d-flex justify-center">
    <VTextField
      v-for="(val, index) in values"
      :key="'2fa-' + index"
      ref="inputs"
      v-model="values[index]"
      :autofocus="index === 0"
      :disabled="disabled"
      hide-details
      outlined
      maxlength="1"
      type="tel"
      @keydown="$event => keydown($event, index)"
      @focus="focus"
      @input="value => input(value, index)"
      @paste="paste"
    />
  </div>
</template>

<style lang="scss">
.linked-text-fields {
  .v-text-field {
    flex-grow: 0;
    margin-right: 0.5rem !important;
    width: 3rem;

    &:nth-child(3) {
      margin-right: 1.5rem !important;
    }

    &:last-child {
      margin-right: 0 !important;
    }

    input {
      text-align: center;
    }
  }
}
</style>
